const { fetchJSON } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcher(countryCode)
      // this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = this.getStoredCountry()

      this.setupCountrySwitcher(countryCode)
      // this.updateShippingLabel(countryCode)
    } else {
      fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then((res) => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcher(countryCode)
        // this.updateShippingLabel(countryCode)
      })
    }

    this.setupListeners()
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then((res) => {
      const userCountry = this.normaliseCountryCode(
        res.detected_values.country.handle,
      )

      if (!userCountry || !this.countries?.[userCountry]) return

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter((item) => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)

    if (this.els?.options?.exists) {
      this.els.options.elements.forEach((optionEl) => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }
  }

  setStorageFromURL (countryCode) {
    const normalisedCode = this.normaliseCountryCode(countryCode)

    if (!normalisedCode || !this.countries?.[normalisedCode]) return

    if (this.countries[normalisedCode].site === this.currentStore) {
      this.setStoredCountry(normalisedCode)
    }
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code

    this.els.confirm.elements.forEach((confirmEl) => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
    })
  }

  onConfirmClick (event) {
    event.preventDefault()

    let windowPathname = window.location.pathname

    const subdomainFolder = windowPathname.split('/').filter((item) => {
      return item.indexOf('en-') > -1
    })

    if (subdomainFolder) {
      windowPathname = windowPathname
        .replace(subdomainFolder, '')
        .replace('//', '/')
    }

    const normalisedCode = this.normaliseCountryCode(
      event.currentTarget.dataset.code,
    )
    const selectedCountry = this.countries?.[normalisedCode]

    if (selectedCountry && selectedCountry.site === this.currentStore) {
      this.setStoredCountry(normalisedCode)

      this.els['localisation-select'].element.value = normalisedCode
      this.els['localisation-select'].element.dispatchEvent(
        new Event('change'),
      )
    } else if (event.currentTarget.hasAttribute('data-url')) {
      window.location.href = `${event.currentTarget.dataset.url}${windowPathname}?country=${event.currentTarget.dataset.code}`
    }
  }

  updateShippingLabel (countryCode) {
    if (this.noLocationStored) return

    const upperCountryCode = this.normaliseCountryCode(countryCode)

    if (!upperCountryCode) return

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name

      if (this.externalEls?.country?.exists) {
        this.externalEls.country.elements.forEach((countryExternalEl) => {
          countryExternalEl.innerHTML = `${name}`
        })
      }

      /* Added due to trigger in mobile menu being rendered after page load */
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-store-switcher-external-el="country"]')
          .forEach((el) => {
            el.innerHTML = `${name}`
          })
      }, 1000)
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach((triggerExternalEl) => {
        triggerExternalEl.style.opacity = 1
      })
    }
  }

  setupCountrySwitcher (countryCode) {
    const normalisedCode = this.normaliseCountryCode(countryCode)

    this.createOptions(normalisedCode)
    this.setDefaultConfirmButtonURL()

    if (normalisedCode && this.countries?.[normalisedCode]) {
      if (this.countries[normalisedCode].site === this.currentStore) {
        this.setStoredCountry(normalisedCode)
      }
    }

    if (!this.noLocationStored || this.countryParam !== null) {
      window.BAO.eventBus.dispatchEvent(
        window.BAO.EVENTS.STORE_SWITCHER.CORRECT_STORE,
      )

      return
    }

    if (normalisedCode && this.countries?.[normalisedCode]) {
      if (this.countries[normalisedCode].site === this.currentStore) {
        this.setStoredCountry(normalisedCode)
        window.BAO.eventBus.dispatchEvent(
          window.BAO.EVENTS.STORE_SWITCHER.CORRECT_STORE,
        )
        return
      }
    }

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  createOptions (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value
      const isCurrentSite =
        countryCode && key.toLowerCase() === countryCode.toLowerCase()
      this.els.options.element.innerHTML += this.createModalElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )

      this.externalEls.drawer.element.innerHTML += this.createDrawerElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })
  }

  createModalElement (code, site, isCurrentSite, country, currency) {
    return `<option
      data-code="${code}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country} / ${currency}
    </option>`
  }

  createDrawerElement (code, site, isCurrentSite, country, currency) {
    return `<li class="drw-StoreSwitcher_Item">
      <a
        class="drw-StoreSwitcher_Link fz-12_120"
        href="${this.sites[site].url}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
      >
        ${country} / ${currency}

        <span class="drw-StoreSwitcher_Arrow">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8">
            <path fill="currentColor" fill-rule="evenodd" d="M0 0h8v8H7V1.707L1.354 7.354 1 7.707.293 7l.353-.354L6.293 1H0V0Z" clip-rule="evenodd"/>
          </svg>
        </span>
      </a>
    </li>`
  }

  setDefaultConfirmButtonURL () {
    const selectedOptionValue = this.els.options.element.value
    const selectedOptionCode =
      this.els.options.element.options[this.els.options.element.selectedIndex]
        .dataset.code

    this.els.confirm.elements.forEach((confirmEl) => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
    })
  }

  get noLocationStored () {
    const storedCountry = this.getStoredCountry()

    return (
      storedCountry == null ||
      (storedCountry === undefined && !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'P448-BAO-localization'
  }

  get storageCookieName () {
    return 'p448_store_country'
  }

  get currentStore () {
    if (this.dataset?.store) return this.dataset.store

    const hostname = window.location.hostname.toLowerCase()

    if (hostname.startsWith('us.')) return 'US'
    if (hostname.startsWith('uk.')) return 'UK'

    return 'EMEA'
  }

  normaliseCountryCode (countryCode) {
    if (!countryCode) return null

    return String(countryCode).trim().toUpperCase()
  }

  getStoredCountry () {
    let storedCountry = null

    try {
      storedCountry = window.localStorage.getItem(this.userLocationName)
    } catch (error) {
      storedCountry = null
    }

    if (!storedCountry) {
      storedCountry = this.getCookie(this.storageCookieName)
    }

    return this.normaliseCountryCode(storedCountry)
  }

  setStoredCountry (countryCode) {
    const normalisedCode = this.normaliseCountryCode(countryCode)

    if (!normalisedCode) return

    try {
      window.localStorage.setItem(this.userLocationName, normalisedCode)
    } catch (error) {
      console.error(error)
    }

    this.setCookie(this.storageCookieName, normalisedCode, 365)
  }

  getCookie (name) {
    const cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))

    return cookieValue ? cookieValue.split('=')[1] : null
  }

  setCookie (name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    const secureFlag = window.location.protocol === 'https:' ? '; Secure' : ''

    document.cookie = `${name}=${value}; Expires=${expires}; Path=/; SameSite=Lax${secureFlag}`
  }

  get sites () {
    return {
      US: {
        url: 'https://us.p448.com',
      },
      UK: {
        url: 'https://uk.p448.com',
      },
      EMEA: {
        url: 'https://p448.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
